"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CaptchaConfig = void 0;
exports.CaptchaConfig = {
    attSiteKeys: {
        secretKey: '6LdMeCIUAAAAAOwX9oOidg-CsGwYGitguJlL6vj-',
        siteKey: '6LdMeCIUAAAAAFHYMFkObspfKRx0nomc_jUooKnB',
        siteKeyV3: '6LeZpLgZAAAAANETaW8pbTYkKc9QUU60StgO_5EO',
    },
    personalSitekeys: {
        secretKey: '6LeXfpcUAAAAAMMu6-d3QwsLqSqvQ8KxQfQpIydR',
        siteKey: '6LeXfpcUAAAAALTB0vvp-tRX_3j3Rq56zW8TH6tC',
    },
};
//# sourceMappingURL=CaptchaGenerator.config.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/CaptchaGenerator/CaptchaGenerator.config.js
// module id = 1114
// module chunks = 8